import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Do I have to give up my phone entirely?',
  answer: 'No. The protocol uses a "Dopamine-Buffer" method to gently shift your brain from high-frequency scrolling to deep sleep mode—without banning devices. It\'s about transition, not deprivation.'
}, {
  question: "What if I've been a night owl my whole life?",
  answer: "The 11PM Reset doesn't force an early bedtime. It helps you break the uncontrolled digital loop so that whenever you choose to sleep, it's intentional and deep. You can still stay up late, but you'll be in control of when you stop."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 sm:px-6 lg:px-8" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-13">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white" data-id="element-14">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-15">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-navy-800 border-indigo-500/50' : 'bg-navy-900 border-navy-700 hover:border-navy-600'}`} data-id="element-16">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-17">
                  <span className="font-heading text-lg font-medium text-white pr-4" data-id="element-18">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="flex-shrink-0 text-amber-500" data-id="element-19">
                    <ChevronDownIcon className="w-6 h-6" data-id="element-20" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-21">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-22">
                      <div className="px-6 pb-6 text-slate-300 leading-relaxed" data-id="element-23">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}